import { render, staticRenderFns } from "./PolicyFilesModal.vue?vue&type=template&id=eee1ee78&scoped=true&"
import script from "./PolicyFilesModal.vue?vue&type=script&lang=js&"
export * from "./PolicyFilesModal.vue?vue&type=script&lang=js&"
import style0 from "./PolicyFilesModal.vue?vue&type=style&index=0&id=eee1ee78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eee1ee78",
  null
  
)

export default component.exports